import * as Sentry from "@sentry/nextjs";
import { getPlatformLinkByEnvironment } from "constants/platform-links";

const isProduction = process.env.NODE_ENV === "production";

export const PLATFORM_MANIFEST_ASSETS_CDN_DOMAIN = "http://webpack.vcap.me:3444";
export const PLATFORM_STAGING_CDN_URL = "https://multicdn.mondaystaging.com";
export const PLATFORM_PROD_CDN_URL = "https://cdn.monday.com";

export const PLATFORM_CDN_URL = isProduction ? PLATFORM_PROD_CDN_URL : PLATFORM_STAGING_CDN_URL;
const PLATFORM_MANIFEST_ENDPOINT = `${PLATFORM_CDN_URL}/build/manifest.json`;

export const getPlatformManifest = async () => {
  try {
    const request = await fetch(getPlatformLinkByEnvironment(PLATFORM_MANIFEST_ENDPOINT), {
      method: "GET",
      pragma: "no-cache"
    });

    const response = await request.json();
    return { success: response.success, response };
  } catch (e) {
    Sentry.captureException(e);
    return { success: false };
  }
};
